/** 锚点定位 */
import { useEventListener } from "@vueuse/core";

export const anchorTop = {
  mounted: (el, binding) => {
    const { arg, value } = binding;
    if (value === "top") {
      el.scrollIntoView();
    }
    useEventListener(el, "change", () => {
      if (value !== "top") {
        el.scrollIntoView();
      }
    });
  },
  beforeUnmount(el) {}
};
